import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { ref: "widget" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = ["data-fit"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.hasScore)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("button", {
            class: "NavigatorButton FitText Widget",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.incentiveClicked && _ctx.incentiveClicked(...args))),
            ref: "tag"
          }, _toDisplayString(_ctx.fitText), 513 /* TEXT, NEED_PATCH */)
        ]))
      : (_openBlock(), _createElementBlock("button", {
          key: 1,
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.incentiveClicked && _ctx.incentiveClicked(...args))),
          class: "NavigatorButton FitText js-Widget",
          "data-fit": _ctx.fitText
        }, _toDisplayString(_ctx.fitText), 9 /* TEXT, PROPS */, _hoisted_3))
  ], 512 /* NEED_PATCH */))
}